export const OPTION_CHAINTOOL = "OPTION_CHAINTOOL";
export const OPTION_CHAINTOOL_ERROR = "OPTION_CHAINTOOL_ERROR";
export const OPTION_CHAINTOOL_HIDE_ERROR = "OPTION_CHAINTOOL_HIDE_ERROR";
export const OPTION_CHAINTOOL_START_LOADER = "OPTION_CHAINTOOL_START_LOADER";
export const OPTION_CHAINTOOL_STOP_LOADER = "OPTION_CHAINTOOL_STOP_LOADER";
export const OPTION_CHAINTOOL_EXPIRY_DATE_DATA = "OPTION_CHAINTOOL_EXPIRY_DATE_DATA";
